import { Typography } from '@sravni/react-design-system';
import cn from 'classnames';

import { FinancialRisksNoticeTexts } from '../FinancialRisksNotice.texts';

import styles from './FinancialRisksNotice.module.scss';

type Props = {
  noticeText?: string;
};

export const FinancialRisksNotice: FC<Props> = (props) => {
  const { noticeText, className } = props;
  return (
    <div className={cn(styles.financialRisksNotice, className)}>
      <Typography.Text size={14}>{noticeText || FinancialRisksNoticeTexts.notice} </Typography.Text>
    </div>
  );
};
